import '../libs/polyfills/polyfills'
import Header from './../modules/header/header';
import Accordion from './../modules/accordion/accordion';
import Stage from './../modules/stage/stage';
import NewsTeaser from './../modules/news-teaser/news-teaser';
import ProductSlider from './../modules/product-slider/product-slider';
import CrisisLayer from './../modules/crisis-layer/crisis-layer';
import LangSwitcher from './../modules/lang-switcher/lang-switcher';
import Video from '../modules/video/video';


new Header();
new Accordion();
new Stage();
new LangSwitcher();


// Add page-loaded class to avoid opacity transition on page load
window.addEventListener( 'load', () => {
    document.querySelector( 'body' ).classList.add( 'page-loaded' );
} );

document.querySelectorAll( '.news-teaser' ).forEach( () => {
    new NewsTeaser();
} );

document.querySelectorAll( '.product-slider' ).forEach( item => {
    new ProductSlider( item );
} );

document.querySelectorAll( '.video' ).forEach( item => {
    new Video( item );
} );

document.querySelectorAll( '.block-views-blockkrisenlayer-block-1' ).forEach( item => {
    new CrisisLayer( item );
} );

document.querySelectorAll( '.nutrition-bubbles__bubbles .content svg' ).forEach( item => {
    item.removeAttribute( 'width' );
    item.removeAttribute( 'height' );
} );